import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuántas sesiones tiene SAINT®?",
    answer:
      "SAINT® administra 50 sesiones de estimulación durante cinco días consecutivos: aproximadamente 10 sesiones por día, cada una de unos minutos, con descansos de aproximadamente 50 minutos entre sesiones.",
  },
];

export const esHowManySessions = makeEsArticle({
  slug: "how-many-saint-tms-sessions",
  title: "¿Cuántas sesiones tiene SAINT® TMS?",
  description:
    "SAINT® administra 50 sesiones durante cinco días consecutivos: unas 10 sesiones por día con descansos de aproximadamente 50 minutos.",
  h1: "¿Cuántas sesiones tiene SAINT® TMS?",
  breadcrumbLabel: "Número de sesiones de SAINT®",
  shortAnswer:
    "SAINT® administra 50 sesiones de estimulación magnética transcraneal durante cinco días consecutivos. Cada día incluye aproximadamente 10 sesiones, cada una de unos minutos, con descansos de aproximadamente 50 minutos entre sesiones. El paciente permanece despierto durante todo el tratamiento. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® administra 50 sesiones en cinco días.",
    "Cada día incluye aproximadamente 10 sesiones.",
    "Los descansos entre sesiones son de aproximadamente 50 minutos.",
    "El paciente permanece despierto.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "El calendario de SAINT®",
      paragraphs: [
        "SAINT® comprime el tratamiento en cinco días consecutivos. La TMS convencional, en comparación, suele administrar 30 a 36 sesiones, una por día, durante unas seis semanas.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
